import { forTemplate } from 'app/common/lib/util/i18n';
import l from 'app/scripts/lib/localize.coffee';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Spinner } from 'app/src/components/Spinner';
import styles from './ChooseDate.less';
import { Button } from '@trello/nachos';
import { ChecklistTestIds } from '@trello/webdriverio-tests/test-ids';

const format = forTemplate('choose_date');

interface ChooseDateProps {
  dateInitial: Date | undefined;
  onSelect: (date: Date | null) => void;
  onReady?: () => void;
  testId?: ChecklistTestIds;
}

function getPikadayStrings() {
  return {
    previousMonth: l('prev month button text'),
    nextMonth: l('next month button text'),
    months: moment.months(),
    weekdays: moment.weekdays(),
    weekdaysShort: moment.weekdaysMin(),
  };
}

export function ChooseDate({
  dateInitial,
  onReady,
  onSelect,
}: ChooseDateProps) {
  const [loading, setLoading] = useState(true);
  const [field, setField] = useState<HTMLInputElement | null>(null);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const [selectedDate, setSelectedDate] = useState(dateInitial);

  useEffect(() => {
    if (field && container) {
      import(/* webpackChunkName: "pikaday" */ 'pikaday').then(
        ({ default: Pikaday }) => {
          new Pikaday({
            field,
            container,
            bound: false,
            format: 'l',
            firstDay: moment.localeData().firstDayOfWeek(),
            i18n: getPikadayStrings(),
            keyboardInput: false,
            onSelect: setSelectedDate,
            defaultDate: dateInitial,
            setDefaultDate: true,
          });
          setLoading(false);
          onReady?.();
        },
      );
    }
  }, [field, container, onReady, onSelect, dateInitial]);

  return (
    <>
      <input type="hidden" ref={setField} />
      <div
        ref={setContainer}
        role="button"
        onMouseUp={() => {
          if (selectedDate && selectedDate !== dateInitial) {
            onSelect(selectedDate);
          }
        }}
      />
      {loading && <Spinner centered />}
      <div className={styles.buttons}>
        <Button
          onClick={() => onSelect(null)}
          shouldFitContainer
          isDisabled={!dateInitial}
          data-test-id={ChecklistTestIds.ChecklistItemRemoveDateButton}
        >
          {format('remove-date')}
        </Button>
      </div>
    </>
  );
}
